var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bxs-radio-group',{staticClass:"show-radio",model:{value:(_vm.radioValue),callback:function ($$v) {_vm.radioValue=$$v},expression:"radioValue"}},_vm._l((_vm.options),function(item,index){return _c('bxs-radio',{key:index,attrs:{"name":item.value,"data-stat-id":item.stat}},[_vm._t("default",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }